import './scss/index.scss';
import { dcFactory } from 'dc';

import { PledgeWallComponent } from './js/pledge-wall.component';
dcFactory.register(PledgeWallComponent);

import { PledgePageComponent } from './js/pledge-page.component';
dcFactory.register(PledgePageComponent);
